<cb-dialog>
    <form class="flex-col flex" #form="ngForm">
        <cb-select
            label="Template Section"
            name="specGroupId"
            [required]="true"
            [options]="houseAreas"
            [(ngModel)]="item.specGroupId"
        ></cb-select>
        <cb-select
            label="Cost Type"
            name="costType"
            [options]="scheduleTemplateCostTypes"
            [required]="true"
            [(ngModel)]="item.costType"
        >
        </cb-select>
        @if (item.costType !== COST_TYPE_ENUM.DescriptiveOnly) {
            <cb-product-autocomplete-scroller
                class="cb-margin-right"
                label="Product"
                name="selectProduct"
                [(ngModel)]="selectedProduct"
                [required]="true"
                [isInvalid]="!selectedProduct?.id"
                [requireMatch]="true"
                [matchProps]="['id']"
                [categoryId]="offeringCategoryId"
                [hideCompositeItems]="true"
                (searchTextChanged)="productSearchTextChanged($event)"
                (optionSelected)="productUpdate($event)"
            >
            </cb-product-autocomplete-scroller>
        }
        @if (item.costType === COST_TYPE_ENUM.DescriptiveOnly) {
            <cb-input
                label="Description"
                name="productOther"
                [required]="true"
                [(ngModel)]="item.productOther"
            ></cb-input>
        }
        <div class="product-card cb-margin-bottom-2x flex-row flex">
            <div class="flex-col" id="imageUploadDropzone" style="max-width: 180px">
                <div class="start-center flex-row">
                    @if (item.costType === COST_TYPE_ENUM.Actual || !item.specItemImage) {
                        <cb-image-button [baseUrl]="item.productImageUrl" class="image-button">
                        </cb-image-button>
                    }
                    @if (item.costType !== COST_TYPE_ENUM.Actual && item.specItemImage) {
                        <cb-image-button [baseUrl]="item.specItemImage" class="image-button">
                        </cb-image-button>
                    }
                </div>
                <input
                    hidden
                    type="file"
                    #fileInput
                    (change)="selectFile($event, form.form)"
                    (click)="setEventTargetValueNull($event)"
                    [disabled]="uploadingImage || item.costType === COST_TYPE_ENUM.Actual"
                    accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/gif,image/png"
                />
                <div>
                    <button
                        mat-button
                        (click)="fileInput.click()"
                        style="display: block"
                        [disabled]="uploadingImage || item.costType === COST_TYPE_ENUM.Actual"
                    >
                        <mat-icon>delete</mat-icon>
                        @if (!item.productImageUrl && !item.specItemImage) {
                            <span> &nbsp;Upload Image </span>
                        }
                        @if (item.productImageUrl || item.specItemImage) {
                            <span> &nbsp;Replace Image </span>
                        }
                    </button>
                    @if (item.specItemImage && item.costType !== COST_TYPE_ENUM.Actual) {
                        <button mat-button style="display: block" (click)="removeImage(form.form)">
                            <mat-icon>delete</mat-icon>
                            &nbsp;Remove Image
                        </button>
                    }
                </div>
            </div>
            <div class="flex-col flex">
                @if (!item.productOther) {
                    <ul class="simple-breadcrumbs">
                        @for (cat of selectedProduct?.categoryPath; track cat) {
                            <li>{{ cat?.label || cat }}</li>
                        }
                    </ul>
                }
                @if (!item.productOther) {
                    <h3 class="mat-subtitle-2">
                        {{ selectedProduct?.code }} {{ selectedProduct?.name ? '-' : '' }}
                        {{ selectedProduct?.name }}
                    </h3>
                }
                @if (!shouldHideQuantity) {
                    <cb-input
                        name="quantity"
                        label="Quantity"
                        type="number"
                        [required]="true"
                        [suffix]="productUom"
                        [(ngModel)]="item.quantity"
                    >
                    </cb-input>
                }
                @if (isSupplierViewable()) {
                    <cb-select
                        name="supplierSelect"
                        label="Supplier"
                        [options]="suppliers"
                        [(ngModel)]="item.supplierId"
                    >
                    </cb-select>
                }
                @if (
                    item.costType &&
                    item.costType !== COST_TYPE_ENUM.Actual &&
                    item.costType !== COST_TYPE_ENUM.NoCharge &&
                    item.costType !== COST_TYPE_ENUM.DescriptiveOnly
                ) {
                    <cb-currency
                        [label]="getRateLabel()"
                        name="rateSnapshot"
                        [(ngModel)]="item.rateSnapshot"
                        [required]="
                            item.costType !== COST_TYPE_ENUM.Actual &&
                            item.costType !== COST_TYPE_ENUM.NoCharge
                        "
                        [inclGst]="item.costType === COST_TYPE_ENUM.Provisional"
                    >
                    </cb-currency>
                }
            </div>
        </div>
        <cb-nullable-boolean
            label="Include in Flyer / Create Schedule"
            name="showInClientSpecification"
            [(ngModel)]="item.showInClientSpecification"
            nullLabel="Not Set (Inherit from Product)"
        >
        </cb-nullable-boolean>
        <cb-nullable-boolean
            label="Include in Colour Schedule"
            name="showInColourYourDreams"
            [(ngModel)]="item.showInColourYourDreams"
            nullLabel="Not Set (Inherit from Product)"
        >
        </cb-nullable-boolean>
        <cb-nullable-boolean
            label="Manual Colour Entry Required"
            name="manualColourEntryRequired"
            [(ngModel)]="item.manualColourEntryRequired"
            nullLabel="Not Set (Inherit from Product)"
        >
        </cb-nullable-boolean>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
